import { mappers } from '@wix/premium-cart-common';
import { cyclePriceDisplayPropsFromProductPricing } from '../../premium-pricing-api-client';
export const enrichPriceSummmary = props => {
  var _lineItem$priceSummar;
  const {
    lineItem,
    currencySettings,
    pricingInfo
  } = props;
  if (!lineItem.cycle) {
    // TODO - error handling
    throw new Error('line item has no cycle');
  }
  const cycle = mappers.CartCycleToDynamicCycle(lineItem.cycle);
  if (!cycle.interval) {
    // TODO - error handling
    throw new Error('cycle has no valid interval');
  }
  const quantity = lineItem.seats ?? 1;
  const interval = cycle.interval;
  const cyclePricingProps = cyclePriceDisplayPropsFromProductPricing({
    interval,
    catalogPricing: (pricingInfo == null ? void 0 : pricingInfo.catalogPricing) ?? [],
    currencySettings: currencySettings ?? {},
    quantity
  });
  if (!((_lineItem$priceSummar = lineItem.priceSummary) != null && _lineItem$priceSummar.subTotal)) {
    // TODO - error handling
    throw new Error('no subtotal price from cart');
  }
  if (!lineItem.priceSummary.beforeTax) {
    // TODO - error handling
    throw new Error('no beforeTax price from cart');
  }

  // When sale all data come from cart service
  return {
    ...lineItem.priceSummary,
    cyclePricingProps,
    maximalTotalPriceDecimal: Number(lineItem.priceSummary.subTotal),
    totalSavingsDecimal: Number(lineItem.priceSummary.subTotal) - Number(lineItem.priceSummary.beforeTax)
  };
};
//# sourceMappingURL=price-summary.enricher.js.map